/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanStatementHeaderOutputDto { 
    name?: string | null;
    loanNumber?: string | null;
    loanProduct?: string | null;
    noOfInstallment?: number;
    tenureType?: string | null;
    intrestRate?: number;
    loanAmount?: number;
    intrestAmount?: number;
    principleOutstanding?: number;
    intrestOutstanding?: number;
    loanOfficer?: string | null;
    postalAddress?: string | null;
    disbursmentDate?: string;
    refNo?: string | null;
}

